import { ReactNode } from "react";
import { iconColor, orange, text } from "@/modules/irohana-components/theme/colors-new";
import { FCC } from "@/modules/irohana-components/types/common";
import { ButtonNew, TButtonNewProps } from "@/modules/irohana-components/elements/ButtonNew/ButtonNew";
import { Stack } from "@mui/material";
import { IconCheckCircleFill, IconNavigationCancel } from "@/modules/irohana-components/assets/icons";

export type TStatusButtonNewStatus = "default" | "checked" | "error";

export type TStatusButtonNewProps = {
  status?: TStatusButtonNewStatus;
  icon?: ReactNode;
} & Omit<TButtonNewProps, "variant">;

const statusIcons: Record<TStatusButtonNewStatus, ReactNode> = {
  default: <IconCheckCircleFill color={text.disable} fontSize={16} />,
  checked: <IconCheckCircleFill color={iconColor.primary} fontSize={16} />,
  error: <IconNavigationCancel color={orange[80]} fontSize={16} />,
};

export const StatusButtonNew: FCC<TStatusButtonNewProps> = ({ status = "default", icon, disabled, children, ...rest }) => {
  return (
    <ButtonNew variant="secondary" disabled={disabled} {...rest} sx={{ position: "relative", gap: "8px", paddingLeft: "0 !important", ...rest.sx }}>
      <Stack
        sx={{
          width: "20px",
          paddingLeft: "4px",
        }}
      >
        {icon ?? statusIcons[status]}
      </Stack>
      {children}
    </ButtonNew>
  );
};
